const INITIAL_STATE = {
  atividades: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ATIVIDADES_FETCH':
      return { ...state, atividades: action.payload }
    default:
      return state
  }
}